import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login } from '@/store/actions'
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "@/auth";
import { IconAlertTriangle } from '@tabler/icons-react';
import { useLoginData } from "@/store/context/LoginContext";
import { AppDispatch } from "@/store";

import { github } from "@/lib/github-auth";
import { useLocation } from "react-router-dom"; // If using React Router


export default function Login() {
  const dispatch = useDispatch<AppDispatch>();
  const { loading, userData, error } = useSelector((state: any) => state.auth); 
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const navigate = useNavigate();
  const [isLoading, setIsLoggedIn] = useState(false)
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const location = useLocation(); // Access current URL path

  const {user, setUser} = useLoginData();


  const handleLogin = async () => {
    let valid = true;
    setIsLoggedIn(true)
    setUsernameError("");
    setPasswordError("");

    if (!username.trim()) {
      setUsernameError("Username is required");
      valid = false;
    }
    if (!password.trim()) {
      setPasswordError("Password is required");
      valid = false;
    }

    if (valid) {
      dispatch(login(username, password));
    }
    setIsLoggedIn(false)
  };

  useEffect(() => {
    if(isAuthenticated()){
      if(userData){
        setUser(userData);
        navigate('/');
      }
      
    }
  }, [loading]);

 
const clientId = "Ov23liGSoYjKlZfFRk9q"
const clientSecret = "2ab36285e80612dff599d74a5d6c2368b6621374"

const githubLogin = async () => {
  try {
    const githubLoginUrl = github.redirect({
      clientId,
    });
    console.log(githubLoginUrl);

    // Auto-redirect to the GitHub login URL
    window.location.href = githubLoginUrl;
  } catch (error) {
    console.error("Error during GitHub login:", error);
  }
};


 
  useEffect(() => {
    const params = new URLSearchParams(location.search); // Extract query params
    const codeFromUrl = params.get("code");
    if(codeFromUrl){
      gitLogin(codeFromUrl)
    }
  }, [location]);

  const gitLogin = async (AuthCode: string) => {
    try {
      const tokens = await github.getTokensFromCode(AuthCode, { clientSecret, clientId });
      const accessToken = tokens.access_token;
      // logger.log(`[access_token], ${JSON.stringify(accessToken)}`, 'info');
      const providerUser = await github.getUser(accessToken);
      // return {
      //   user: providerUser,
      //   tokens
      // };

      console.log("[providerUser]", providerUser);
    } catch (error) {
      console.error("Error during GitHub token exchange:", error);
    }
  }

  return (
    <div className="container w-full h-full min-h-screen flex justify-center items-center">
      <Card>
        <CardHeader>
        {error && 
        <p className="text-red-500 flex items-center">
        <IconAlertTriangle className="text-red-500 mr-2" />
        {error}
      </p>      
        }
          <CardTitle>Login</CardTitle>
          <CardDescription>Please login with valid username and password</CardDescription>
          <Button onClick={githubLogin} >Github</Button>
        </CardHeader>
        <CardContent>
          <form>
            <div className="grid w-full items-center gap-4">
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="username">Username</Label>
                <Input
                  id="username"
                  placeholder="Enter your username"
                  onChange={(e) => setUsername(e.target.value)}
                  value={username}
                />
                {usernameError && (
                  <p className="text-red-500 text-sm">{usernameError}</p>
                )}
              </div>
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="password">Password</Label>
                <Input
                  type="password"
                  id="password"
                  placeholder="Enter your password"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                />
                {passwordError && (
                  <p className="text-red-500 text-sm">{passwordError}</p>
                )}
              </div>
             
            </div>
          </form>
        </CardContent>
        <CardFooter className="flex justify-between">
          <Button variant="outline">Cancel</Button>
          <Button onClick={handleLogin} disabled={isLoading}>
            {isLoading ? "Loading..." : "Login"}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
